import { mdiCheck, mdiCircleMedium, mdiMinus } from '@mdi/js';
import React from 'react';
import { Icon } from '@upgrade/react-components';
import { IconContainer, Item, List } from './styles';
import { Text } from '../TypographyPublicSite';
import { toHtmlSanitize } from '../../../utils/remark-html';

const icons = {
  dash: mdiMinus,
  circle: mdiCircleMedium
};

const getIcon = iconName => icons[iconName] || mdiCheck;

/**
 * @deprecated Use HighlightsV2 instead.
 */
const Highlights = ({ highlights, color, icon, iconColor }) => {
  const highlightIcon = getIcon(icon);
  return (
    <List>
      {highlights?.map(({ item, superscript }) => (
        <Highlight
          key={item}
          icon={highlightIcon}
          iconColor={iconColor}
          item={item}
          superscript={superscript}
          color={color}
        />
      ))}
    </List>
  );
};

/**
 * @deprecated Use HighlightsV2 instead.
 */
export const Highlight = ({ item, superscript, color, icon = mdiCheck, iconColor, iconBackgroundColor }) => {
  return (
    <Item iconBackgroundColor={iconBackgroundColor}>
      <IconContainer iconBackgroundColor={iconBackgroundColor}>
        <Icon color={iconColor || 'actionablePrimary'} size="small" icon={icon} />
      </IconContainer>
      <Text
        size="sm"
        color={color || 'contentWeak'}
        dangerouslySetInnerHTML={{ __html: toHtmlSanitize(item, { removeWrappingPTag: true }).trim() }}
      />
      {superscript && (
        <Text color={color || 'contentWeak'}>
          <sup>{superscript}</sup>
        </Text>
      )}
    </Item>
  );
};

export default Highlights;
